/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_CreditsInputs */

const zh_usage_credits = /** @type {(inputs: Usage_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分变更`)
};

const en_usage_credits = /** @type {(inputs: Usage_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const es_usage_credits = /** @type {(inputs: Usage_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Usage_CreditsInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const usage_credits = /** @type {((inputs?: Usage_CreditsInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_CreditsInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_credits(inputs)
	if (locale === "en") return en_usage_credits(inputs)
	return es_usage_credits(inputs)
});